module.exports = __webpack_public_path__ + "img/FTP_1.cb78ae35.png";